/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-packing-fees';

export const EntityPackingFeesApi = {
  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: EntityPackingFeeQuery) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface EntityPackingFeeQuery {
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  tab?: string;
  reserved?: boolean;
  ownerID?: string;
}
